import axios from 'axios'
import { RESPONSE_ERROR_HANDLER_POSTPONE_HEADER } from '../../util/responseUtil'
import {URL} from '../../util/ambienteActions';

export const CADASTRAR_BLOQUEIO_POLTRONAS_TEMPORARIO = '@bloqueioPoltronasTemporarioActions/CADASTRAR_BLOQUEIO_POLTRONAS_TEMPORARIO';
export const LIBERAR_BLOQUEIO_POLTRONAS_TEMPORARIO = '@bloqueioPoltronasTemporarioActions/LIBERAR_BLOQUEIO_POLTRONAS_TEMPORARIO';

const OFFLINE_AWARE_CONFIG = {
    headers: {
        'X-Slow-Request': true,
        [RESPONSE_ERROR_HANDLER_POSTPONE_HEADER]: true
    }
}

export function criarBloqueioPoltronasTemporario(dados) {
    let url = `${URL}/bloqueio-poltrona-temporario`;
    return dispatch => axios.post(url, dados, OFFLINE_AWARE_CONFIG)
        .then(response => dispatch({
            type: CADASTRAR_BLOQUEIO_POLTRONAS_TEMPORARIO,
            payload: response
        }))
        .catch(erro => {
            if (!navigator.onLine || !erro.response) {
                return dispatch({
                    type: CADASTRAR_BLOQUEIO_POLTRONAS_TEMPORARIO,
                    payload: { status: 200, data: { ...dados, id: `offline_${Date.now()}` } }
                });
            }
            throw erro;
        });
}

export function liberarBloqueioPoltronasTemporario(ids) {
    const liberarLocal = dispatch => dispatch({
        type: LIBERAR_BLOQUEIO_POLTRONAS_TEMPORARIO,
        payload: ids
    });

    const idsBackend = ids.filter(id => !`${id}`.startsWith('offline_'));
    if (!idsBackend.length) {
        return liberarLocal;
    }

    const url = `${URL}/bloqueio-poltrona-temporario/liberar`;
    return dispatch => axios.post(url, idsBackend, OFFLINE_AWARE_CONFIG)
        .then(() => liberarLocal(dispatch))
        .catch(erro => {
            if (!navigator.onLine || !erro.response) return liberarLocal(dispatch);
            throw erro;
        });
}
